import * as React from 'react';
import { toast } from "react-toastify";
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import CKEditor from '../../../ckeditor/safe-ckeditor';
import Button from 'react-bootstrap/Button';
import Tooltip from 'react-bootstrap/Tooltip';
import { IoInformation } from "react-icons/io5";
import { BsBoxArrowInRight } from "react-icons/bs";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';

import axios from '../../../../axios';
import apiError from '../../../../error';
import Loader from '../../../loader/loader';
import ImportEmail from '../../../create-template/import-email/import-email';
import Spinner from '../../../spinner/spinner';
import ImportEmailFromStore from '../../../create-template/templates/import-email-from-store';
import DeepfakeAttachmentModal from '../../../create-template/templates/deepfake-attachment-modal';
import { getCookie, isTruthyValue } from '../../../../function';
import HtmlPreviewEditor from '../html-preview-editor';

export default class Templates extends React.Component {
    constructor(props) {
        super(props);
        this.fileRef = React.createRef(null);
        this.state = {
            show: false,
            subject: '',
            loading: false,
            defaultSubject: true,
            tracking: true,
            loadHtml: false,
            attachments: [],
            emailContent: '',
            changeUrls: false,
            attachmentKey: [],
            loadingImport: false,
            attachmentWithNoTemplateId: [],
            htmlKey: 1,
            filename: "",
            colorCode: "",
            updateHtml: "",
            showImportModal: false,
            showDeepfakeModal: false,
            storeTemplateId: null,
            htmlContent: (this.props.templateResponse) ? this.props.templateResponse[this.props.currentIndex] : '',
            html: (this.props.templateResponse) ? this.props.templateResponse[this.props.currentIndex] : '<html> <head> <title></title> </head> <body data-gr-ext-disabled="forever" data-gr-ext-installed="" data-new-gr-c-s-check-loaded="14.991.0"> <p>{{.tracker}}</p> </body> </html>',

            isShowEditor: false,
        }
    }

    componentDidMount = () => {
        this.setState({ colorCode: this.props.backgroundHeader })
        if (this.props.backgroundHeader || this.props.logoPosition) {
            if (this.props.backgroundHeader === null) this.props.updateBackgroundHeader(this.props.defaultColor)
            if (this.props.logoPosition === null) this.props.updateLogoPosition("left")
            let patternHeader = new RegExp(/\.Aitemplate-header\s*{\s*background-color:\s*#[0-9a-fA-F]+;[^}]*text-align:\s*(center|left|right)/g);
            let patternFooter = new RegExp(/\.Aitemplate-footer\s*{\s*background-color:\s*#[0-9a-fA-F]+;/g);
            let str = this.state.htmlContent.replace(patternHeader, `.Aitemplate-header { \n background-color: ${this.props.backgroundHeader};\n padding: 20px;\n text-align: ${this.props.logoPosition}`);
            str = str.replace(patternFooter, `.Aitemplate-footer {\n  background-color: ${this.props.backgroundHeader};\n padding: 20px;\n`);
            this.setState({ updateHtml: str })
            this.setState({ html: str })
        }
        if (this.state.defaultSubject) {
            this.setState({ subject: this.props.subContent })
        }
        this.loadTemplate();
        setTimeout(() => {
            this.setState({ htmlKey: this.state.htmlKey + 1 });
        }, 1500);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.templateId !== this.props.templateId) {
            this.loadTemplate();
        }
    }

    loadTemplate = () => {
        if (this.props.templateId) {
            axios.get('/api/emails/' + this.props.templateId, {})
                .then(res => {
                    this.setState({
                        loadHtml: true,
                        html: res.data.template.html,
                        subject: res.data.template.subject,
                        attachments: res.data.template.attachments,
                        filename: res.data.template.attachments[0] ? res.data.template.attachments[0].filename : "",
                        tracking: res.data.template.html.search('{{.tracker}}') > -1,
                        htmlKey: this.state.htmlKey + 1,
                    })
                })
                .catch(err => {
                    apiError(err)
                })
        } else this.setState({ loadHtml: true })
    }

    handleChangeSubject = (e) => {
        this.setState({ defaultSubject: false })
        const userSubject = e.target.value;
        this.setState({ subject: userSubject });
    }

    handleChange = (e) => {
        let html = e.editor.getData();
        let tracking = html.search('{{.tracker}}') > -1;
        this.setState({ html: html, tracking: tracking });
    }

    handleCreateTemplate = () => {
        if (!this.state.html || this.state.html.length === 0) {
            toast.error("Please Enter HTML Content");
            return;
        } else if (this.state.subject.length === 0 || (this.state.subject).trim().length === 0) {
            toast.error("Please Enter Email Subject");
            return;
        }
        const data = {
            html: this.state.html,
            subject: this.state.subject,
            campaignTemplateId: this.props.campaignTemplateId
        }
        this.setState({ loading: true })
        if (this.props.templateId) {
            axios.patch('/api/emails/' + this.props.templateId, data)
                .then(res => {
                    this.setState({ loading: false })
                    this.giveTemplateIdtoAttachment();
                    this.props.handleTabChange('next');
                })
                .catch(error => {
                    apiError(error)
                    this.setState({ loading: false })
                })
        } else {
            axios.post('/api/emails/', data)
                .then(res => {
                    this.setState({ loading: false })
                    this.props.handleTabChange('next');
                    this.giveTemplateIdtoAttachment();
                    this.props.handleTemplateId(res.data.template.id);
                    toast.success('Email template created successfully')
                })
                .catch(error => {
                    apiError(error)
                    this.setState({ loading: false })
                })
        }
    }

    giveTemplateIdtoAttachment = () => {
        if (this.state.attachmentKey && this.state.attachmentKey.length) {
            setTimeout(() => {
                axios.post('/api/attachment/key', {
                    templateId: this.props.templateId,
                    attachmentKey: this.state.attachmentKey
                })
                    .then(res => { this.loadAttachment(); this.setState({ attachmentKey: [] }) })
                    .catch(error => { })
            }, 1000);
        } else if (this.state.storeTemplateId) {
            setTimeout(() => {
                axios.post('/api/attachment/store-key', {
                    templateId: this.props.templateId,
                    storeTemplateId: this.state.storeTemplateId
                })
                    .then(res => { this.loadAttachment(); this.setState({ attachmentKey: [], storeTemplateId: null }) })
                    .catch(error => { })
            }, 1000);
        }
    }

    handleApiForAttachments = (formData) => {
        return axios.post('/api/attachment', formData, {
            headers: {
                "Content-type": "multipart/form-data",
            }
        })
            .then(res => {
                toast.success('Attachment uploaded');
                if (this.props.templateId) {
                    this.loadAttachment()
                } else {
                    if (res.data?.attachment) {

                        let attachments = [...this.state.attachments, res.data.attachment];
                        let attachmentKey = this.state.attachmentKey;
                        attachmentKey.push(res.data?.attachment?.attachmentKey)

                        this.setState({
                            attachments,
                            attachmentKey
                        })
                    }
                }
            })
    }

    normalizeFileName = (name = "") => {
        return name
            .normalize("NFKC")
            .replace(/[\u00A0\u202F\u2007]/g, " ")
            .replace(/[\u200B-\u200D\uFEFF]/g, "")
            .replace(/\s+/g, " ")
            .trim();
    }

    handleUploadAttachment = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const safeFileName = this.normalizeFileName(file.name);
        const templateId = this.props.templateId;
        const storeTemplateId = this.state.storeTemplateId;

        let formData = new FormData();
        formData.append('files', file, safeFileName);
        formData.append('templateId', templateId);

        this.setState({ filename: safeFileName, loading: true });
        try {
            if (storeTemplateId && templateId) {
                await axios.post('/api/attachment/store-key', {
                    templateId,
                    storeTemplateId
                });
                this.setState({ attachmentKey: [], storeTemplateId: null });
            }
            await this.handleApiForAttachments(formData);
        } catch (error) {
            apiError(error);
        } finally {
            this.setState({ loading: false });
        }
    }

    handleDeleteAttachment = (attachmentId) => {
        this.fileRef.current.value = "";
        axios.delete('/api/attachment/' + attachmentId, {})
            .then(r => {
                this.setState({
                    attachments: this.state.attachments.filter(
                        (attachment) => attachment.id !== attachmentId
                    ),
                });
                toast.success('Attachment deleted');
                if (this.props.templateId) this.loadAttachment();
            })
            .catch(error => apiError(error))
    }

    loadAttachment = () => {
        axios.get('/api/emails/' + this.props.templateId, {})
            .then(res => {
                this.setState({ attachments: res.data?.template?.attachments ?? [] })
            })
            .catch(err => {
                apiError(err)
            })
    }

    addTrackingImage = (e) => {
        if (e.target.checked) {
            let html = this.state.html;
            if (html.indexOf(new RegExp('{{.tracker}}', "gi")) === -1) {
                html = html.replace('</body>', '<p>{{.tracker}}</p></body>');
            }
            this.setState({ html: html, tracking: true, htmlKey: this.state.htmlKey + 1 });
        } else {
            let html = this.state.html.replace(new RegExp('<p>{{.tracker}}</p>', "gi"), '');
            this.setState({ html: html, tracking: false, htmlKey: this.state.htmlKey + 1 });
        }
    }

    handleImportEmail = async () => {
        if (this.state.emailContent.length === 0) {
            toast.error("Please Enter Original Email Content");
            return;
        }
        this.setState({ loadingImport: true });
        axios.post('/api/import/mail', {
            raw: this.state.emailContent,
            changeUrls: this.state.changeUrls ? 1 : 0
        })
            .then(res => {
                this.setState({
                    loadingImport: false,
                    htmlKey: this.state.htmlKey + 1,
                    attachmentKey: res.data.attachmentKey,
                    html: res.data.html ? res.data.html : '',
                    updateHtml: res.data.html ? res.data.html : '',
                });
                this.handleImportEmailModal();
            })
            .catch(err => {
                apiError(err)
                this.setState({ loadingImport: false });
            })
    }

    handleImportEmailModal = () => {
        this.setState({ show: !this.state.show });
    }

    handleChangeUrl = () => {
        this.setState({ changeUrls: !this.state.changeUrls });
    }

    handleContent = (e) => {
        this.setState({
            emailContent: e.target.value
        })
    }
    getHtml = () => this.state.updateHtml || this.state.html || "";
    applyGeneratedHtml = (html) => {
        if (!html) return;
        this.setState({
            html,
            updateHtml: html,
            tracking: html.search('{{.tracker}}') > -1,
            htmlKey: this.state.htmlKey + 1,
        });
    }

    handleLoadSelectedStoreTemplateHtml = async (html, subject, emailTracking, attachments, storeTemplateId) => {
        if (this.fileRef.current) {
            this.fileRef.current.value = "";
        }
        const templateId = this.props.templateId;
        this.setState({
            html: html,
            storeTemplateId,
            updateHtml: html,
            subject: subject,
            htmlKey: this.state.htmlKey + 1,
            attachmentKey: [],
            attachments: attachments.map((attachment, index) => ({ id: index, filename: attachment })),
            filename: attachments.length ? attachments[0] : '',
            tracking: emailTracking,
            loading: Boolean(templateId),
        });

        if (!templateId) return;

        try {
            await axios.post('/api/attachment/store-key', {
                templateId,
                storeTemplateId
            });
            this.setState({ attachmentKey: [], storeTemplateId: null });
            this.loadAttachment();
        } catch (error) {
            apiError(error);
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        return (
            <>
                <div className='email-template-wrap'>
                    <div className='rightSectionHeader'>
                        <div className="row justify-content-between align-items-center">
                            <div className="col-md-4 tab-right-header">
                                <h6>Email Details</h6>
                                <p>Design the phishing email content</p>
                            </div>
                            <div className="col-md-8 text-right">
                                {isTruthyValue(getCookie("isDeepFakeEnabled")) && 
                                    <OverlayTrigger
                                        placement='top'
                                        overlay={<Tooltip id='top'>Create and attach AI-generated audio</Tooltip>}>
                                        <Button variant="secondary" type="button" onClick={() => this.setState({ showDeepfakeModal: true })} className="mr-2">Deepfake Attachment</Button>
                                    </OverlayTrigger>
                                }
                                {!(this.props.attackType === "WhatsApp" && this.props.targetInteractionType === "inbound" && this.props.isAIbased) && 
                                    <OverlayTrigger
                                        placement='top'
                                        overlay={<Tooltip id='top'>Import an email from our template store</Tooltip>}>
                                        <Button variant="secondary" type="button" onClick={() => this.setState({ showImportModal: true })} className="mr-2">Import From Store</Button>
                                    </OverlayTrigger>
                                }
                                <OverlayTrigger
                                    placement='top'
                                    overlay={<Tooltip id='top'>Add any custom email to add it as a template</Tooltip>}>
                                    <Button variant="primary" type="button" onClick={this.handleImportEmailModal}><BsBoxArrowInRight className='btn-icon' />Import From Email</Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                    <div className='setMarginCss'>
                        <Form>
                            <Form.Group>
                                <Form.Label>Email Subject</Form.Label>
                                <Form.Control type="text" value={this.state.subject} onChange={this.handleChangeSubject} placeholder="Enter email subject" />
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='setMarginCss'>
                        {this.state.loadHtml ?
                            <HtmlPreviewEditor
                                label="Email Template"
                                html={this.state.updateHtml ? this.state.updateHtml : this.state.html}
                                promptBar={this.props.promptBar}
                            >
                                <CKEditor
                                    editorUrl={`${process.env.REACT_APP_API_URL}/staticpra/ckeditor/ckeditor.js`}
                                    config={{
                                        fullPage: true,
                                        allowedContent: true
                                    }}
                                    key={this.state.htmlKey}
                                    initData={this.state.updateHtml ? this.state.updateHtml : this.state.html}
                                    data={this.state.updateHtml ? this.state.updateHtml : this.state.html}
                                    onChange={this.handleChange}
                                ></CKEditor>
                            </HtmlPreviewEditor> : null
                        }
                    </div>
                    <div className='checkBoxWrap setMarginCss ml-1'>
                        <Form.Group controlId="formBasicCheckbox" className='mb-0'>
                            <Form.Check type="checkbox" label="Add Tracking Image" checked={this.state.tracking} onChange={this.addTrackingImage} />
                            <OverlayTrigger
                                placement='top'
                                overlay={<Tooltip id='top'>Track the user activity on the sent emails</Tooltip>}>
                                <IoInformation className="tooltip-icon "></IoInformation>
                            </OverlayTrigger>
                        </Form.Group>
                    </div>
                    <div className='row'>
                        <div className='col-md-5'>
                            <Form>
                                <Form.Group>
                                    <Form.Label>Upload Email Attachment</Form.Label>
                                    <Form.File className='form-control' id="exampleFormControlFile1" ref={this.fileRef} disabled={this.state.loading} onChange={this.handleUploadAttachment} />
                                </Form.Group>
                            </Form>
                            {this.state.attachments?.length > 0 &&
                                <div className="tableContainerWrapInner">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>File Name</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.attachments.map((attachment, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{attachment.filename}</td>
                                                        <td><DeleteOutlineTwoToneIcon style={{ cursor: "pointer" }} color='error' onClick={e => this.handleDeleteAttachment(attachment.id)}></DeleteOutlineTwoToneIcon></td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <div className='footer-wrapper justify-content-end d-flex ft-padding'>
                        <Button variant="secondary" className="btn closeBtn mr-2" onClick={e => this.props.handleTabChange('prev')}><ArrowBackOutlinedIcon className="btn-icon"></ArrowBackOutlinedIcon> Previous</Button>
                        <Button className='btn btn-success' disabled={this.state.loading} type="button" onClick={this.handleCreateTemplate}><Spinner loading={this.state.loading}></Spinner><ArrowForwardOutlinedIcon className={this.state.loading ? "btn-icon d-none" : "btn-icon"}></ArrowForwardOutlinedIcon> Go To Next</Button>
                    </div>
                </div>
                <ImportEmail
                    show={this.state.show}
                    changeUrls={this.state.changeUrls}
                    handleContent={this.handleContent}
                    handleChangeUrl={this.handleChangeUrl}
                    emailContent={this.state.emailContent}
                    handleImportEmail={this.handleImportEmail}
                    handleImportEmailModal={this.handleImportEmailModal}
                ></ImportEmail>
                <ImportEmailFromStore
                    showImportModal={this.state.showImportModal}
                    handleClose={e => this.setState({ showImportModal: false })}
                    handleLoadSelectedStoreTemplateHtml={this.handleLoadSelectedStoreTemplateHtml}
                    attackType={this.props.attackType}
                ></ImportEmailFromStore>
                <DeepfakeAttachmentModal
                    show={this.state.showDeepfakeModal}
                    handleClose={() => this.setState({ showDeepfakeModal: false })}
                    templateId={this.props.templateId}
                    onAttachmentAdded={(attachment) => {
                        if (this.props.templateId) {
                            this.loadAttachment();
                        } else {
                            let attachments = [...this.state.attachments, attachment];
                            let attachmentKey = this.state.attachmentKey;
                            attachmentKey.push(attachment.attachmentKey);
                            this.setState({ attachments, attachmentKey });
                        }
                    }}
                />
                {this.state.loadingImport ? <Loader></Loader> : null}
            </>
        )
    }
}
